import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE = `https://api.dilanaslan.com/api/about`;

// Async thunk: About bilgilerini getir
export const fetchAbout = createAsyncThunk(
  "about/fetchAbout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_BASE);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Async thunk: About bilgisini güncelle
// payload = { title, content, image } (image string URL veya base64 olabilir)
export const updateAbout = createAsyncThunk(
  "about/updateAbout",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(API_BASE, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const aboutSlice = createSlice({
  name: "about",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Gerekirse ekstra reducers buraya
  },
  extraReducers: (builder) => {
    builder
      // fetchAbout
      .addCase(fetchAbout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAbout.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAbout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "About bilgisi alınamadı";
      })

      // updateAbout
      .addCase(updateAbout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAbout.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateAbout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "About bilgisi güncellenemedi";
      });
  },
});

export default aboutSlice.reducer;
